import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import moment from 'moment';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      minWidth: 120,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return moment(row.date_save).format('YYYY-MM-DD');
      },
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
      align: 'left',
    },
    {
      prop: 'boxes_quantity',
      label: i18n.t('production.boxes_quantity'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return Formatter.formatNumber(row.boxes_quantity);
      },
    },
    {
      prop: 'location_inspection.name',
      label: i18n.t('boxinspection.inspection_location'),
      minWidth: 150,
      sortable: true,
      align: 'left',
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
